export enum PublicAppBarTestIds {
  CATALOG_TAB = 'public-appbar-catalog-tab',
  ORDER_TAB = 'public-appbar-order-tab',
  SHOWROOM_TAB = 'public-appbar-showroom-tab',
}
